'use strict';

import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Studium} from '../model/studium';
import {Subscription} from 'rxjs';
import {ZapisnyList} from '../model/zapisnyList';

@Component({
    selector: 'app-zapisny-list-selector',
    templateUrl: './zapisny-list-selector.component.html',
    styleUrls: ['./zapisny-list-selector.component.css'],
    standalone: false
})
export class ZapisnyListSelectorComponent implements OnInit, OnDestroy {

    zapisneListy: Studium[] = [];
    private zapisneListySubscription: Subscription;
    activeList: ZapisnyList;
    constructor(private appService: AppService) {
    }

    ngOnInit(): void {
        console.log('ZapisnyListSelectorComponent.ngOnInit');

        this.zapisneListySubscription =
            this.appService.zapisneListySubject.subscribe(
                (data) => {
                    this.activeList = null;
                    this.zapisneListy = data;

                    const idZapisnyList = this.appService.getIdZapisnyList();

                    if (idZapisnyList !== null) {
                        this.zapisneListy.forEach((s) => {
                            const zl = s.zapisneListy.find(i => idZapisnyList === i.id);
                            if (zl) {
                                this.activeList = zl;
                            }
                        });
                    }

                    if (this.activeList === null && this.zapisneListy && this.zapisneListy.length > 0) {
                        this.activeList = this.zapisneListy[0].zapisneListy[0];
                    }

                    this.onSelectionChange(this.activeList);
                });

        this.zapisneListy = this.appService.getZapisneListy();
        this.activeList = this.appService.getZapisnyListSelected();
    }

    ngOnDestroy(): void {
        this.zapisneListySubscription.unsubscribe();
    }

    onSelectionChange(zapisnyList: ZapisnyList) {
        this.appService.setZapisnyListSelected(zapisnyList);
    }
}
